import { render, staticRenderFns } from "./DialerWrapUp.vue?vue&type=template&id=f4cc8386&"
import script from "./DialerWrapUp.vue?vue&type=script&lang=js&"
export * from "./DialerWrapUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports